<template>
  <div class="departmentLits">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
      <template slot="controls">
        <!-- <el-button type="danger" icon="el-icon-delete"
         :disabled="selectedList.length==0">删除</el-button> -->
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleEdit('')"
          >添加</el-button
        >
        <el-button type="danger" @click="handleDel">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dept_name"
        align="center"
        show-overflow-tooltip
        label="部门名称"
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column label="操作" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </div>
          <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            @click="resetPassword(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加管理员 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑部门</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="部门名称" prop="dept_name">
              <el-input v-model="addForm.dept_name" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "departmentLits",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   user:"",
      //   userId:"",
      //   organ:"",
      //   organId:"",
      //   role:"",
      //   roleId:"",
      //   roleType:"",
      //   name:"",
      //   tel:"",
      //   sex:"",
      //   address:"",
      //   create:"",
      //   status:""
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      addDrawer: false /**新增管理员drawer */,
      /**表单数据 */
      //机构id 用户名 密码 角色id 联系方式 性别 修改时该管理员id
      addForm: {
        dept_id: "",
        dept_name: "",
      },
      formRule: {
        /**表单验证 */ dept_name: [mustFill],
      },
      searchForm: {
        /**搜索表单 */ name: "",
        status: "99",
      },
      selectedList: [] /**select选中项 */,
      /**注册表单需要的数据-------------- */
      roleList: [] /**管理角色 */,
      organList: [] /**机构数据 */,
    };
  },
  components: {},
  mounted() {
    this.getRole(); //获取角色列表
    this.getOrgan(); //获取机构列表
    this.getTableData(); //获取管理员列表
  },
  methods: {
    updata() {
      this.getRole(); //获取角色列表
      this.getOrgan(); //获取机构列表
      this.getTableData(); //获取管理员列表
    },
    /**获取管理员数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      this.$request({
        url: "Management/DepartmentAdmin/DepartmentList",
        method: "post",
        data: {
          pageIndex: this.currPage,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.success) {
            this.tableData = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**获取角色选项 */
    getRole() {
      this.$request({
        url: "Role/RoleList",
        method: "post",
        data: {
          Source: "B2B",
          status: "99",
          strWhere: "",
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then((res) => {
          if (res.Code) {
            this.roleList = [];
            for (let i = 0; i < res.Obj.length; i++) {
              this.roleList.push({
                label: res.Obj[i].RoleName,
                value: res.Obj[i].Id + "",
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取机构选项 */
    getOrgan() {
      this.$request({
        url: "Role/EntidAdd",
        method: "post",
      })
        .then((res) => {
          if (res.Code) {
            this.organList = [];
            let entId = window.localStorage.getItem("entId");
            for (let i = 0; i < res.Obj.length; i++) {
              if (entId == "SUPERINTEND") {
                this.organList.push({
                  label: res.Obj[i].entname,
                  value: res.Obj[i].entid,
                });
              } else {
                if (entId == res.Obj[i].entid) {
                  this.organList.push({
                    label: res.Obj[i].entname,
                    value: res.Obj[i].entid,
                  });
                }
              }
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 确定重置密码吗
    resetPassword(row) {
      let data = {
        dept_id: row.dept_id,
      };
      this.$request({
        method: "post",
        url: "Management/DepartmentAdmin/DeleteDepartment",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**编辑管理员数据 */
    handleEdit(row) {
      this.clearForm();
      if (row) {
        for (const key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**修改账户状态 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      } else if (status == 1) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定启用吗?";
        type = "success";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "PC_SetUserInfo",
            strWhere: "'" + row.userId + "'",
            uptype: status,
          };
          let proc = "Proc_Admin_MembersQuery"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "manage/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              //提示成功，刷新数据
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            dept_id: this.addForm.dept_id, //新增时dept_id 默认 0  修改时使用列表返回的dept_id
            dept_name: this.addForm.dept_name, //部门名称
          };
          console.log(data);
          this.$request({
            url: "Management/DepartmentAdmin/EditDepartment",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.clearForm();
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**删除角色 */
    handleDel() {
      if (this.selectedList.length == 1) {
        this.$confirm("确定删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            let row = this.selectedList[0];
            this.changeStatus(row, 0);
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.departmentLits {
  width: 100%;
  height: 100%;
}
</style>
